import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import AdBanner from '../components/AdBanner';

export default function LandingPage() {
  const { t, language, setLanguage, languages } = useLanguage();
  const navigate = useNavigate();
  const [languageSelected, setLanguageSelected] = useState(false);

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
    setLanguageSelected(true);
  };

  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      <div className="absolute inset-0 hero-gradient pointer-events-none" />
      <div className="noise-overlay" />

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6">
        {/* Logo — large, centered */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="mb-4 flex flex-col items-center"
        >
          <img
            src="/logo.png"
            alt="Spiritual Gems"
            className="w-64 h-64 object-contain mx-auto"
            style={{ mixBlendMode: 'screen' }}
            data-testid="landing-logo"
          />
          <img
            src="/logo-pred.png"
            alt="Preaching"
            className="w-32 h-32 object-contain rounded-full -mt-4 mx-auto"
            style={{ mixBlendMode: 'screen' }}
          />
        </motion.div>

        {/* Title */}
        <motion.h1
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.15 }}
          className="text-2xl font-[var(--font-heading)] tracking-[-0.02em] text-foreground mb-5 text-center"
          data-testid="landing-title"
        >
          {t('welcome_title')}
        </motion.h1>

        {/* Language selector + Enter button */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.25 }}
          className="flex items-center gap-2 w-full max-w-sm mb-6"
        >
          <select
            value={language}
            onChange={handleLanguageChange}
            className="flex-1 px-3 py-3 rounded-xl border border-border bg-card text-foreground text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-primary"
            data-testid="landing-language-select"
          >
            {languages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.nativeName}
              </option>
            ))}
          </select>
          <motion.button
            whileTap={{ scale: 0.97 }}
            onClick={() => navigate('/home')}
            className="px-6 py-3 rounded-xl bg-primary text-primary-foreground font-medium shadow-[0_10px_25px_-18px_hsl(var(--shadow-color)/0.65)] hover:bg-primary/90 transition-colors text-sm whitespace-nowrap"
            data-testid="landing-enter-button"
          >
            {t('enter_app')}
          </motion.button>
        </motion.div>

        {/* Ezoic Ad — appears after language selection */}
        <AnimatePresence>
          {languageSelected && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="w-full max-w-sm"
            >
              <AdBanner placeholderId="ezoic-pub-ad-placeholder-101" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
